import React, { useEffect, useRef, useState } from "react";
import { Download, ImageIcon } from "lucide-react";

const W = 1080;

function wrap(ctx, text, maxW, maxLines) {
  const words = text.split(/\s+/); const lines = []; let cur = "";
  for (const w of words) {
    const test = cur ? `${cur} ${w}` : w;
    if (ctx.measureText(test).width > maxW && cur) { lines.push(cur); cur = w; } else cur = test;
    if (lines.length === maxLines) break;
  }
  if (cur && lines.length < maxLines) lines.push(cur);
  if (lines.length === maxLines && words.join(" ") !== lines.join(" ")) lines[maxLines - 1] = `${lines[maxLines - 1].replace(/\s\S*$/, "")}…`;
  return lines;
}

function rounded(ctx, x, y, w, h, r) {
  ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath();
}

async function draw(canvas, { label, title, dateText, location, site }) {
  const ctx = canvas.getContext("2d");
  canvas.width = W; canvas.height = W;
  ctx.fillStyle = "#7A0C0C"; ctx.fillRect(0, 0, W, W);
  const g = ctx.createRadialGradient(180, 400, 50, 180, 400, 900); g.addColorStop(0, "rgba(255,201,74,0.28)"); g.addColorStop(1, "rgba(255,201,74,0)");
  ctx.fillStyle = g; ctx.fillRect(0, 0, W, W);
  const stripe = ["#7A0C0C", "#D99B26", "#1F5A3A"];
  for (let i = 0; i < W / 24; i++) { ctx.fillStyle = stripe[i % 3]; ctx.fillRect(i * 24, 0, 24, 18); ctx.fillRect(i * 24, W - 18, 24, 18); }
  const logo = new Image(); logo.src = "/logo.png";
  await new Promise((r) => { logo.onload = r; logo.onerror = r; });
  ctx.save(); ctx.beginPath(); ctx.arc(140, 150, 80, 0, Math.PI * 2); ctx.fillStyle = "#FFFDF7"; ctx.fill(); ctx.clip();
  if (logo.complete && logo.naturalWidth) ctx.drawImage(logo, 70, 80, 140, 140); ctx.restore();
  ctx.fillStyle = "#FFFDF7"; ctx.font = "bold 34px Georgia, serif"; ctx.fillText("Okuapemman Association", 250, 140);
  ctx.font = "600 22px monospace"; ctx.fillStyle = "#FFC94A"; ctx.fillText("OF MASSACHUSETTS  ·  EST. 2010", 250, 178);
  ctx.font = "bold 24px monospace"; const lw = ctx.measureText(label.toUpperCase()).width + 60;
  rounded(ctx, 70, 300, lw, 54, 27); ctx.fillStyle = "#FFC94A"; ctx.fill();
  ctx.fillStyle = "#7A0C0C"; ctx.fillText(label.toUpperCase(), 100, 337);
  ctx.fillStyle = "#FFC94A"; ctx.font = "bold 84px Georgia, serif";
  const lines = wrap(ctx, title, W - 140, 3); lines.forEach((l, i) => ctx.fillText(l, 70, 470 + i * 96));
  let y = 470 + lines.length * 96 + 30;
  ctx.fillStyle = "#FFFDF7"; ctx.font = "600 40px sans-serif";
  if (dateText) { ctx.fillText(`📅  ${dateText}`, 70, y); y += 62; }
  if (location) { wrap(ctx, `📍  ${location}`, W - 140, 2).forEach((l) => { ctx.fillText(l, 70, y); y += 54; }); }
  rounded(ctx, 70, W - 150, W - 140, 80, 40); ctx.fillStyle = "rgba(0,0,0,0.25)"; ctx.fill();
  ctx.fillStyle = "#FFC94A"; ctx.font = "bold 30px monospace"; ctx.fillText(`${site.replace(/^https?:\/\//, "")}  ·  @OkuapemmanMA`, 100, W - 98);
  ctx.textAlign = "right"; ctx.fillStyle = "#FFFDF7"; ctx.font = "italic 32px Georgia, serif"; ctx.fillText("Ofie! Biakoye!", W - 100, W - 98); ctx.textAlign = "left";
}

export function PostImageCard({ label = "Important Announcement", title, dateText, location, site }) {
  const ref = useRef(null);
  const [url, setUrl] = useState("");
  useEffect(() => {
    let alive = true;
    (async () => { if (ref.current && title) { await draw(ref.current, { label, title, dateText, location, site }); if (alive) setUrl(ref.current.toDataURL("image/png")); } })();
    return () => { alive = false; };
  }, [label, title, dateText, location, site]);
  const file = `${title.toLowerCase().replace(/[^a-z0-9]+/g, "-").slice(0, 40)}-post.png`;
  return (
    <div className="rounded-xl border border-gold/30 bg-parchment-card p-4" data-testid="post-image-card">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm font-bold"><ImageIcon size={16} className="text-gold" /> Square post image (1080×1080) — Instagram, WhatsApp, Facebook</div>
        <a href={url || "#"} download={file} className={`inline-flex items-center gap-1 rounded-full bg-crimson px-3 py-1 text-xs font-semibold text-parchment hover:bg-crimson-hover ${url ? "" : "pointer-events-none opacity-50"}`} data-testid="post-image-download"><Download size={12} /> Download PNG</a>
      </div>
      <canvas ref={ref} className="hidden" />
      {url && <img src={url} alt={`${title} post card`} className="mt-3 w-full max-w-sm rounded-xl shadow-lg" data-testid="post-image-preview" />}
    </div>
  );
}
